import type { PostMessageSubmission, PostMessageSubProvider } from './types';

/**
 * Typeform embedded form detection.
 *
 * Typeform embeds fire postMessage events with:
 *   { type: 'form-submit', formId: '...', responseId: '...' }
 *
 * Docs: https://www.typeform.com/developers/embed/callbacks/
 */
export const TypeformProvider: PostMessageSubProvider = {
    name: 'typeform',
    trustedOrigins: /^https:\/\/([\w-]+\.)?typeform\.com$/,

    detect(data: Record<string, unknown>): boolean {
        const type = data?.type;
        return (
            (type === 'form-submit' || type === 'form-ready' || type === 'form-screen-changed') &&
            typeof data?.formId === 'string'
        );
    },

    isSubmission(data: Record<string, unknown>): boolean {
        return data?.type === 'form-submit';
    },

    extractData(data: Record<string, unknown>, origin: string): PostMessageSubmission {
        const indicators = ['postmessage_typeform_submitted'];
        if (data?.responseId) {
            indicators.push(`typeform_response:${data.responseId}`);
        }
        return {
            provider: 'typeform',
            formId: (data?.formId as string) || 'typeform_form',
            applyFormIdWhitelist: typeof data?.formId === 'string' && data.formId !== '',
            indicators,
            origin,
        };
    },
};
